module.exports = __webpack_public_path__ + "media/images/emblems/Stadel-blazon-f8772485bc0c1773dbaa97b4d59bc6db.svg";